<template>
  <div class="dovemed-container">
    <div class="dovemed-wrapper text-center signup-page">
      <div class="signup-container" v-if="load">
        <h2 class="hyper-link mb-4 symptomsHeading">
          Symptoms
          <a-tooltip placement="topLeft" overlayClassName="ant-dovemed-tooltip">
            <template slot="title">
              <span> Adding symptoms of your condition will help other members having similar symptoms connect with you. </span>
            </template>
            <!-- <i
              class="fa fa-info-circle"
              aria-hidden="true"
              :style="{
                color: `${currentCircle.color_code} !important`,
                'font-size': '14px',
                position: 'absolute'
              }"
            ></i> -->
            <i class="fa fa-question-circle question-icon" aria-hidden="true" :style="`color:#2A71D4 !important`"></i>
          </a-tooltip>
        </h2>
        <div class="col-md-12 col-sm-12 text-center symptoms-content">
          <p class="bold-text m-0 symptoms-text">
            <!-- {{
              authUser.user.role === "patient"
                ? "What symptoms specific to your condition do you experience?"
                : "What symptoms specific to the condition do the patient experience?"
            }} -->
            {{
              `What symptoms specific to ${currentCircle.condition_type
                .replace("My", "")
                .replace("Circle", "")
                .replace("my", "")
                .replace("circle", "")
                .trim()} do ${authUser.user.role === "patient" ? "you" : "the patient"} experience?`
            }}
          </p>
          <p class="forExample">(For example: abdominal pain etc.)</p>
          <div @click="openSymptomsModal" class="add-symptoms">
            <!-- <div class="left-line"></div>
            <hr class="top-line" />
            <hr class="bottom-line" /> -->
            <div class="plus-icon">
              <!-- <img src="../../../assets/images/plus-icon.png" /> -->
              <font-awesome-icon size="1x" class="mr-2" :style="{ color: getPrimaryColor() }" :icon="['fas', 'plus']" />
            </div>
            <span class="addsymtoms-text" :style="{ color: getPrimaryColor() }"> Add Symptoms </span>
          </div>
          <div v-if="symptoms" :class="symptoms.length ? 'symptomsCard' : ''">
            <div class="d-flex display-symptom mt-3" v-for="(symptom, index) in symptoms" :key="index">
              <div class="displaysymptom-wrapper">
                <div :style="{ 'text-align': 'left', display: 'inline-block' }" class="symptom-group">
                  <div class="symptomDisplayName">
                    {{ symptom.display_name }}
                  </div>
                  <div
                    :style="{
                      color: getEffectivenessColor(symptom.effectiveness),
                      background: `${getEffectivenessColor(symptom.effectiveness)}25`,
                      padding: '4px 8px',
                      height: 'fit-content',
                      'border-radius': '4px',
                      'margin-top': '8px',
                      'font-size': '12px',
                      'font-weight': '700',
                      display: 'inline-block',
                    }"
                  >
                    {{ getEffectiveness(symptom.effectiveness) }}
                  </div>
                </div>
              </div>

              <div class="position-relative my-auto">
                <div class="d-flex align-items-center deleteText cp" @click="() => (showDelete = index)">
                  <font-awesome-icon
                    size="1x"
                    :style="{
                      color: '#FF9999',
                      transform: 'translateY(-1.5px)',
                    }"
                    :icon="['fas', 'trash']"
                    class="mr-2"
                  />
                  Delete
                </div>
                <div class="position-absolute delete-popup shadow-card" v-if="showDelete === index">
                  <p class="font-black mb-2">Are you sure you want to delete this？</p>
                  <div class="d-flex justify-content-end">
                    <span class="cancel-box cp rounded" @click="() => (showDelete = null)"> Cancel </span>
                    <span class="ok-box cp rounded" @click.stop="() => removeSymptom(symptom.display_name)" :style="{ 'background-color': getPrimaryColor() }"> Ok </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="buttons-group text-right">
            <!-- <router-link
              :to="{ path: 'treatments', query: { role: $route.query.role } }"
              class="float-left"
            > -->
            <router-link :to="{ name: 'UserTreatments', query: { role: $route.query.role } }" class="float-left" :style="{ 'text-decoration': 'none' }">
              <div class="hyper-link skipLink" :style="{ color: getPrimaryColor(), cursor: 'pointer', display: symptoms.length === 0 ? 'inline-block' : 'none' }">
                Skip for later
              </div>
            </router-link>
            <div class="nxt-btn-cont">
              <!-- <a-button
                class="dovemed-button cancelButton"
                :style="{
                  background: '#E2E8F0',
                  display: symptoms.length !== 0 ? 'inline-block' : 'none',
                  color: '#fff !important',
                }"
                @click="
                  () =>
                    this.$router.push({
                      name: 'UserProfileWelcome',
                      params: { role: authUser.user.role },
                      query: { role: authUser.user.role },
                    })
                "
              >
                <span :style="{ color: '#000 !important' }">Back</span>
              </a-button> -->
              <!-- @click="$router.go(-1)" -->
              <a-button
                :loading="loading"
                :disabled="symptoms.length === 0"
                type="submit"
                class="next-button dovemed-button font-white ml-4 primary-button"
                @click.prevent="handleSubmit"
                :style="{
                  background: getPrimaryColor(),
                  color: '#fff !important',
                  opacity: symptoms.length === 0 ? '0.3' : '1',
                }"
              >
                <span :style="{ color: '#fff !important' }">Next</span>
              </a-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <AddSymptomsModal
      ref="addSymptomModal"
      :key="componentReRender"
      :forceRender="forceRender"
    /> -->
    <AddSymptomsModal ref="addSymptomModal" :forceRender="forceRender" />
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators"
import { RepositoryFactory } from "../../../repositories/RepositoryFactory"
import AddSymptomsModal from "../../Modals/profile/Symptoms.vue"

const AppRepository = RepositoryFactory.get("app")
const UserRepository = RepositoryFactory.get("user")

export default {
  name: "UserSymptoms",
  data() {
    return {
      load: false,
      symptoms: [],
      otherSymptoms: [],
      symptomsList: [],
      otherSymptomsList: [],
      loading: false,
      componentReRender: 0,
      showDelete: null,
    }
  },
  components: {
    AddSymptomsModal,
  },
  validations: {
    symptoms: {
      required,
    },
  },

  created() {
    this.init()
    // this.searchSymptoms()
    // this.searchOtherSymptoms();
    // setTimeout(()=>{
    //   document.getElementsByTagName('body')[0].setAttribute('style','height: 100%')
    // }, 500)
  },
  mounted() {
    window.scrollTo(0, 0)
  },

  // watch: {
  //   componentReRender(val) {
  //     console.log("componentReRender ->", componentReRender)
  //   },
  // },

  methods: {
    init() {
      UserRepository.getSymptoms(this.authUser.user, this.currentCircle.id)
        .then(res => {
          if (res.data) {
            this.symptoms = res.data.data.circle_symptoms.map(ele => {
              return {
                display_name: ele.display_name,
                effectiveness: ele.effectiveness,
              }
            })
          } else {
            this.symptom = []
          }

          this.load = true
        })
        .catch(err => null)
    },
    forceRender() {
      // console.log("forceRender called")
      this.componentReRender += 1
    },
    // handleTags(value) {
    //   this.symptoms.push(value)
    // },
    /**
     * Search Symptoms
     */
    // searchSymptoms(value = "") {
    //   AppRepository.searchSymptoms(value, this.currentCircle).then(res => {
    //     this.symptomsList = res.data.data.circle_symptoms ? [...res.data.data.circle_symptoms] : []
    //     this.otherSymptomsList = res.data.data.other_symptoms ? [...res.data.data.other_symptoms] : []
    //   })
    // },

    getEffectiveness(effectiveness) {
      switch (effectiveness) {
        case "0":
          return "Mild"
        case "50":
          return "Moderate"
        case "100":
          return "Severe"
        default:
          break
      }
    },

    getEffectivenessColor(effectiveness) {
      switch (effectiveness) {
        case "0":
          return "#14DE0D"
        case "50":
          return "#F6B156"
        case "100":
          return "#FF4400"
        default:
          break
      }
    },

    /**
     * Handle symptoms selection
     */
    // handleSymptoms(value) {
    //   this.symptoms = value
    //   this.changeColor(value, "c-select_a")
    // },

    /**
     * Add Symptoms
     */
    async handleSubmit() {
      this.loading = true
      const payload = {
        symptoms: this.symptoms ? this.symptoms : [],
        other_symptoms: this.otherSymptoms ? this.otherSymptoms : [],
      }
      const headers = {
        Authorization: `Bearer ${this.authUser.user.token}`,
      }

      const url = `${process.env.BASE_API_URL}/${this.authUser.user.role === "patient" ? "symptoms" : "caregiversymptoms"}/?user_id=${this.authUser.user.id}&circle_id=${this.currentCircle.id}`
      if (this.symptoms) {
        await this.$store.dispatch("Signup/updateNormalUser", {
          url,
          payload,
          headers,
        })
        this.loading = false
        this.$router.push({
          name: "UserTreatments",
          query: { role: this.authUser.user.role },
        })
      } else {
        this.loading = false
        this.$router.push({
          name: "UserTreatments",
          query: { role: this.authUser.user.role },
        })
      }
    },
    // changeColor(value, className) {
    //   setTimeout(() => {
    //     this.$el
    //       .querySelectorAll("." + className)[0]
    //       .children[0].children[0].querySelector("ul")
    //       .querySelectorAll("li")
    //       .forEach(elem => {
    //         if (elem.classList.contains("ant-select-selection__choice")) {
    //           elem.setAttribute("style", ` background: ${this.currentCircle.color_code} !important ; color: white !important`)
    //         }
    //         if (elem.classList.contains("ant-select-selection__choice__content")) {
    //           elem.setAttribute("style", ` color: white !important`)
    //         }
    //       })
    //   }, 10)
    // },
    openSymptomsModal() {
      this.$refs.addSymptomModal.show([], [], this.init)
      // this.$refs.addSymptomModal.show("", [], [], this.init);
    },
    removeSymptom(symptom) {
      // console.log("removeSymptom() called");
      const payload = {
        symptom: this.symptoms.filter(ele => ele.display_name !== symptom),
      }
      const headers = {
        Authorization: `Bearer ${this.authUser.user.token}`,
      }
      const url = `${process.env.BASE_API_URL}/${this.authUser.user.role === "patient" ? "symptoms" : "caregiversymptoms"}/?user_id=${this.authUser.user.id}&circle_id=${this.currentCircle.id}`
      if (this.symptoms) {
        this.$store.dispatch("Signup/updateNormalUser", { url, payload, headers }).then(() => {
          // window.location.reload();
          this.symptoms = payload.symptom
          // console.log("symptoms ->", this.symptoms);
        })
      }
      this.showDelete = null
    },
  },
}
</script>

<style lang="scss" scoped>
*:disabled {
  background: #a1bde6;
  opacity: 0.5;
}

.symptomsHeading {
  color: #1e2945 !important;
  font-family: "Lato";
  font-weight: 700;
  font-size: 36px;
}

.symptoms-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.symptoms-text {
  font-weight: 700;
  font-size: 16px;
  color: #647490;
}
.question-icon {
  font-size: 20px;
  margin: 0 6px;
  position: absolute;
  cursor: pointer;
}
.forExample {
  margin: 8px 0 72px 0;
  color: #647490;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
}
.add-symptoms {
  // width: 540px;
  max-width: 540px;
  width: 90%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 24px 0;
  height: 72px;
  background: rgba(37, 103, 237, 0.05);
  // background-image: linear-gradient(#94a3b8 33%, rgba(255, 255, 255, 0) 0%);
  // background-position: right;
  // background-size: 1px 16px;
  // background-repeat: repeat-y;
  position: relative;
  cursor: pointer;
  border: 1px dashed #94a3b8;
  // .border-top,
  // .border-bottom {
  //   position: absolute;
  //   border: none;
  //   left: 7px;
  //   margin: 0;
  // }
  // .border-top {
  //   top: -25px;
  //   &::after {
  //     content: "_ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _";
  //     letter-spacing: 4px;
  //     height: 0;
  //     overflow: hidden;
  //     color: #94a3b8;
  //   }
  // }
  // .border-left {
  //   position: absolute;
  //   background-image: linear-gradient(#94a3b8 33%, rgba(255, 255, 255, 0) 0%);
  //   background-size: 1px 17px;
  //   background-repeat: repeat-y;
  //   height: 55px;
  //   width: 10px;
  //   left: 0;
  // }
  // .border-bottom {
  //   bottom: -30px;
  //   &::after {
  //     content: "_ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _";
  //     letter-spacing: 4px;
  //     height: 0;
  //     overflow: hidden;
  //     color: #94a3b8;
  //   }
  // }
  .addsymtoms-text {
    font-family: "Lato";
    font-weight: 700;
    color: #2a71d4;
  }
  // .plus-icon{
  //   // font-size: 30px;
  // }
  .addsymtoms-text {
    font-size: 14px;
    margin: 0 8px;
  }

  @media screen and (max-width: 900px) {
    height: 56px;
    font-size: 14px;
    line-height: 22px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.skipLink {
  font-weight: 700;
  font-size: 14px;
  color: #2a71d4;
}
.symptomsCard {
  width: 75%;
  margin-top: 8px;
  // border: 1px solid #E2E8F0;
  border-radius: 8px;
  padding: 0 16px;
  @media screen and (max-width: 900px) {
    // width: auto;
    // width: 90%;
    width: 100%;
  }
}
.buttons-group {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 70%;
  margin-top: 48px;
}
.display-symptom {
  justify-content: space-between;
  padding: 10px 24px;
  // background: rgba(37, 103, 237, 0.05);
  background: #fff;
  border-radius: 5px;
  height: 82px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  @media screen and (max-width: 900px) {
    height: auto;
  }
  .symptomDisplayName {
    color: #0f1734;
    font-weight: 700;
    font-size: 16px;
    font-family: "Lato";
  }
  .displaysymptom-wrapper {
    display: flex;
    flex-direction: column;
  }
  .deletebtn-wrapper {
    display: flex;
    align-items: center;
    position: relative;
    cursor: pointer;
  }
}

.icon {
  position: absolute;
  left: -35px;
  top: -4px;
}
.deleteText {
  font-weight: 700;
  font-size: 14px;
  color: #ea3100;
}
.dovemed-wrapper {
  max-width: 800px;
}

.dovemed-button {
  padding: 12px 24px;
  @media screen and (max-width: 900px) {
    padding: 12px 32px;
  }
}

.next-button {
  border-radius: 8px;
  span {
    color: #fff !important;
  }
  @media screen and (max-width: 900px) {
    width: 50%;
  }
}
.cancelButton {
  color: #47556e;
  font-weight: 700;
  font-size: 14px;
  font-family: "Lato";
  border-radius: 6px;
}
.ant-btn {
  span {
    color: #000 !important;
  }
}
.delete-popup {
  top: -100px;
  width: 310px;
  z-index: 1;
  left: 0;
  @media screen and (max-width: 900px) {
    // right: 0px;
    left: -220px;
  }
}
.ok-box {
  margin: auto 1em;
  // background: #2A71D4 !important;
  color: white !important;
  padding: 1px 10px;
}
.cancel-box {
  margin: auto 1em;
  background: rgb(226, 232, 240) !important;
  color: black !important;
  padding: 1px 10px;
}

@media screen and (max-width: 600px) {
  .symptoms-content {
    padding-right: 24px !important;
    padding-left: 24px !important;
  }
  .add-symptoms {
    width: 100% !important;
  }
  .buttons-group {
    width: 100% !important;
    .nxt-btn-cont {
      width: 50% !important;
    }
    button {
      margin-left: 0 !important;
      width: 100% !important;
    }
  }
  .symptomsCard {
    padding: 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Signup/UserProfile/Symptoms.vue